const DEFAULT_TRANSITION = 'transform 0.25s ease 0s';
export const reducer = (state, action) => {
  switch (action.type) {
    case 'tick':
      return {
        ...state,
        current: state.current + 1,
        transition: DEFAULT_TRANSITION,
        offset: state.offset - action.payload.width,
        count: action.payload.count,
      };
    case 'reset':
      return { ...state, transition: 'none', current: 0, offset: 0 };
    default:
      return state;
  }
};
